import * as React from 'react';

type Context = {
  loading: boolean;
  setLoading: (loading: boolean) => void;
};
const ProtocolEditContext = React.createContext<Context | null>(null);

export const ProtocolEditProvider = ({ children, ...props }: { children: React.ReactNode } & Context) => {
  return <ProtocolEditContext.Provider value={props}>{children}</ProtocolEditContext.Provider>;
};

export const useProtocolEdit = () => {
  const context = React.useContext(ProtocolEditContext);
  if (!context) {
    throw new Error('useProtocolEdit must be used within a ProtocolEditProvider');
  }
  return context;
};
